/**
 * Hero
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */


import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.hero',

	events: {
		'click .hs-submit .hs-button': 'onFormSubmit',
		'click label.hero__signup-area__btn': 'onLabelClick',
		'change .hs-marketing_material_consent input.hs-input': 'onCheckboxValueChange',
	},

	thankYouModal: {},
	onLabelClick(e) {
		if (window.innerWidth >= 768) {
			e.preventDefault();
		}
	},

	onCheckboxValueChange(e) {
		window.gtmDataMarketingCheckboxChecked = e.delegateTarget.checked;
	},

	onRender() {
		this.populateModal();
	},

	populateModal() {
		const mobileSignupArea = this.el.querySelector('.hero__signup-area__signup');

		//if there's a link, there will be no hubspot form, so it won't try to attach it
		if(mobileSignupArea !== null){
			const data = JSON.parse(mobileSignupArea.dataset.hubspotdata);
			// inject hubspot form
			const hubSpotScript = document.createElement('script');
			const hubSpotForm = `hbspt.forms.create({
				portalId: "${data.portalId}",
				formId: "${data.formId}"
			})`;

			hubSpotScript.appendChild(document.createTextNode(hubSpotForm));
			mobileSignupArea.appendChild(hubSpotScript);
			this.thankYouModal = data.thankYouModal;
		}
	},

	onFormSubmit() {
		window.thankYouModal = this.thankYouModal;
	},
});

export default View;
